import Vue from 'vue'
import Router from 'vue-router'
import maping from '@/TDK/mate.js'

Vue.use(Router)

import HelloWorld from '@/views/HelloWorld'
import Details from '@/views/details.vue'
import Search from '@/views/search.vue'
import Loadpage from '@/views/loadpage.vue'
import saleAll from '@/views/saleAll'
import errorPage from '@/views/errorPage'

const router = new Router({
  mode: 'history',
  routes: [{
      name: 'home',
      path: '/\/.*/',
      redirect: '/',
      meta: {
        keepAlive: true //开启缓存
      }
    }, {
      name: 'HelloWorld',
      path: '/',
      component: HelloWorld,
      meta: maping.HelloWorld
    }, {
      name: 'details',
      path: '/details',
      component: Details,
      meta: maping.details
    }, {
      name: 'search',
      path: '/search',
      component: Search,
      meta: maping.search
    }, {
      name: 'loadpage',
      path: '/loadpage',
      component: Loadpage,
      meta: maping.loadpage
    }, {
      name: 'saleAll',
      path: '/saleAll',
      component: saleAll,
      meta: maping.saleAll
    },
    {
      name: 'errorPage',
      path: '/errorPage',
      component: errorPage,
      meta: maping.errorPage
    },
    {
      path: '*',
      redirect: '/errorPage',
      meta: maping.errorPage
    }
  ]
})
router.beforeEach((to, from, next) => {
  let titleTag = document.getElementsByTagName('title')[0]
  // 去掉所有自增加的meta标签
  let metaTags = document.getElementsByTagName('meta')

  if (metaTags && metaTags.length > 0) {
    for (let i = metaTags.length - 1; i >= 0; i--) {
      if (metaTags[i].dataset && metaTags[i].dataset.vueRouterControlled === 'controll') {
        document.head.removeChild(metaTags[i])
      }
    }
  }

  document.title = to.meta.title
  const addmeta = to.meta.metaTags
  addmeta.forEach(obj => {
    const tag = document.createElement('meta')
    tag.setAttribute('name', obj.name)
    tag.setAttribute('content', obj.content)
    tag.setAttribute('data-vue-router-controlled', 'controll')
    document.head.insertBefore(tag, titleTag)
  })
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js